import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { PageHeading } from 'web-ui-components/lib/typography/headings';
import { Modal } from 'web-ui-components/lib/organisms/modals';
import { Button } from 'web-ui-components/lib/atoms/buttons';
import { ButtonGroup } from 'web-ui-components/lib/molecules/buttons';
import content, { contentPropTypes } from './ViewArchiveModal.content';
import withContent from '../../../containers/withContent';
import {
	MANDATE_TYPE_SCHEDULE_PAYMENT,
	MANDATE_TYPE_STANDING_ORDER,
	MANDATE_TYPE_DIRECT_DEBIT,
	MANDATE_TYPE_BACS_CREDIT,
	MANDATE_TYPE_BACS_DEBIT,
	MANDATE_TYPE_SCHEDULE_TRANSFER,
	MANDATE_TYPE_IFT,
	MANDATE_TYPE_CHAPS,
} from '../../../config';
import ScheduledPaymentDetails from '../PaymentDetails/ScheduledPaymentDetails';
import StandingOrderDetails from '../PaymentDetails/StandingOrderDetails';
import DirectDebitDetails from '../PaymentDetails/DirectDebitDetails';
import BacsCreditPaymentDetails from '../PaymentDetails/BacsCreditPaymentDetails';
import BacsDebitPaymentDetails from '../PaymentDetails/BacsDebitPaymentDetails';
import IFTDetails from '../PaymentDetails/IFTDetails';
import ChapsDetails from '../PaymentDetails/ChapsDetails';
import { getMandateToView } from '../../../states/managePayments/selectors';

const mapState = (state) => ({
	mandate: getMandateToView(state),
});
export const getComponentToRender = (
	{
		archivedDirectDebitHeader,
		archivedStandingOrderHeader,
		archivedScheduledPaymentHeader,
		archivedBacsCreditHeader,
		archivedBacsDebitHeader,
		archivedIFTPaymentHeader,
		archivedCHAPSPaymentHeader,
	},
	{ mandateType }
) =>
	({
		[MANDATE_TYPE_STANDING_ORDER]: {
			header: archivedStandingOrderHeader,
			component: StandingOrderDetails,
		},
		[MANDATE_TYPE_SCHEDULE_PAYMENT]: {
			header: archivedScheduledPaymentHeader,
			component: ScheduledPaymentDetails,
		},
		[MANDATE_TYPE_SCHEDULE_TRANSFER]: {
			header: archivedScheduledPaymentHeader,
			component: ScheduledPaymentDetails,
		},
		[MANDATE_TYPE_DIRECT_DEBIT]: {
			header: archivedDirectDebitHeader,
			component: DirectDebitDetails,
		},
		[MANDATE_TYPE_BACS_CREDIT]: {
			header: archivedBacsCreditHeader,
			component: BacsCreditPaymentDetails,
		},
		[MANDATE_TYPE_BACS_DEBIT]: {
			header: archivedBacsDebitHeader,
			component: BacsDebitPaymentDetails,
		},
		[MANDATE_TYPE_IFT]: {
			header: archivedIFTPaymentHeader,
			component: IFTDetails,
		},
		[MANDATE_TYPE_CHAPS]: {
			header: archivedCHAPSPaymentHeader,
			component: ChapsDetails,
		},
	}[mandateType]);

export const ViewArchiveModal = ({ mandate = {}, handleClose, content }) => {
	const renderHeader = () => <Button onClick={handleClose}>{content.closeLabel}</Button>;
	const renderFooter = () => (
		<ButtonGroup>
			<Button id="close-button`" display="secondary" className="u-margin-right-1" onClick={handleClose}>
				{content.closeLabel}
			</Button>
		</ButtonGroup>
	);
	const { header, component: Component } = getComponentToRender(content, mandate);
	return (
		<Modal size="lg" isOpen header={renderHeader()} footer={renderFooter()}>
			<PageHeading data-test-id="view-archive-modal">{header}</PageHeading>
			<Component mandate={mandate} />
		</Modal>
	);
};

ViewArchiveModal.propTypes = {
	mandate: PropTypes.shape({}),
	handleClose: PropTypes.func.isRequired,
	cancelApiError: PropTypes.shape({
		message: PropTypes.string.isRequired,
	}),
	content: PropTypes.shape(contentPropTypes),
};
const contentWrapper = withContent({ content })(ViewArchiveModal);
export default connect(mapState)(contentWrapper);
